module.exports = __webpack_public_path__ + "static/img/1.c8ecd1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hw/1.jpg
// module id = DJWO
// module chunks = 0